routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider) {
    $stateProvider
        .state('home.boxTextTemplate', {
            url: "box-text-template",
            template: `<box-text-template sh-ctrl="shCtrl"></box-text-template>`
        });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/box-text-template/box-text-template.config.js
 **/